// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"42b66b67","453":"987d0254","796":"aecc435d"}[chunkId] + ".chunk.js";
};